// src/reducers/bankDetailReducers.js

import {
  // UPI
  GET_UPI_DETAILS_REQUEST, GET_UPI_DETAILS_SUCCESS, GET_UPI_DETAILS_FAIL,
  SUBMIT_UPI_DETAILS_REQUEST, SUBMIT_UPI_DETAILS_SUCCESS, SUBMIT_UPI_DETAILS_FAIL,
  DELETE_UPI_DETAILS_REQUEST, DELETE_UPI_DETAILS_SUCCESS, DELETE_UPI_DETAILS_FAIL,
  // Bank
  GET_BANK_DETAILS_REQUEST, GET_BANK_DETAILS_SUCCESS, GET_BANK_DETAILS_FAIL,
  SUBMIT_BANK_DETAILS_REQUEST, SUBMIT_BANK_DETAILS_SUCCESS, SUBMIT_BANK_DETAILS_FAIL,
  DELETE_BANK_DETAILS_REQUEST, DELETE_BANK_DETAILS_SUCCESS, DELETE_BANK_DETAILS_FAIL,
} from '../actions/types';

// --- UPI Reducer ---
const upiInitialState = {
  loading: false,
  upiList: [],
  error: null,
};

export const upiDetailsReducer = (state = upiInitialState, action) => {
  switch (action.type) {
    // GET
    case GET_UPI_DETAILS_REQUEST:
      return { ...state, loading: true };
    case GET_UPI_DETAILS_SUCCESS:
      return { loading: false, upiList: action.payload, error: null };
    case GET_UPI_DETAILS_FAIL:
      return { loading: false, error: action.payload, upiList: [] };

    // SUBMIT
    case SUBMIT_UPI_DETAILS_REQUEST:
        return { ...state, loading: true };
    
    // --- (FIXED) ---
    case SUBMIT_UPI_DETAILS_SUCCESS:
        // Check for nested data property, fallback to payload itself.
        const newUpi = action.payload.data || action.payload; 
        return {
            ...state,
            loading: false,
            // Only add the new item if it's a valid object.
            upiList: newUpi ? [...state.upiList, newUpi] : state.upiList,
        };

    case SUBMIT_UPI_DETAILS_FAIL:
        return { ...state, loading: false, error: action.payload };

    // DELETE
    case DELETE_UPI_DETAILS_REQUEST:
        return { ...state, loading: true };
    case DELETE_UPI_DETAILS_SUCCESS:
        return {
            ...state,
            loading: false,
            upiList: state.upiList.filter(upi => upi.id !== action.payload),
        };
    case DELETE_UPI_DETAILS_FAIL:
        return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};


// --- Bank Reducer ---
const bankInitialState = {
  loading: false,
  bankList: [],
  error: null,
};

export const bankDetailsReducer = (state = bankInitialState, action) => {
    switch (action.type) {
      // GET
      case GET_BANK_DETAILS_REQUEST:
        return { ...state, loading: true };
      case GET_BANK_DETAILS_SUCCESS:
        return { loading: false, bankList: action.payload, error: null };
      case GET_BANK_DETAILS_FAIL:
        return { loading: false, error: action.payload, bankList: [] };
  
      // SUBMIT
      case SUBMIT_BANK_DETAILS_REQUEST:
          return { ...state, loading: true };
      
      // --- (FIXED) ---
      case SUBMIT_BANK_DETAILS_SUCCESS:
          // Check for nested data property, fallback to payload itself.
          const newBank = action.payload.data || action.payload;
          return {
              ...state,
              loading: false,
              // Only add the new item if it's a valid object.
              bankList: newBank ? [...state.bankList, newBank] : state.bankList,
          };

      case SUBMIT_BANK_DETAILS_FAIL:
          return { ...state, loading: false, error: action.payload };
  
      // DELETE
      case DELETE_BANK_DETAILS_REQUEST:
          return { ...state, loading: true };
      case DELETE_BANK_DETAILS_SUCCESS:
          return {
              ...state,
              loading: false,
              bankList: state.bankList.filter(bank => bank.id !== action.payload),
          };
      case DELETE_BANK_DETAILS_FAIL:
          return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };